import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateEventTypeShowsDeviceGroupsDocument } from './update-shows-device-groups.generated';

export const useUpdateEventTypeShowsDeviceGroups = (
  options: ApiOptions<typeof UpdateEventTypeShowsDeviceGroupsDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpdateEventTypeShowsDeviceGroupsDocument, {
    ...useNotifications(UpdateEventTypeShowsDeviceGroupsDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.event_types.update_success'),
    }),

    ...options,
  });
};
